
import isNil from 'lodash/isNil';

function validateFloat(value) {
    return (
        !isNaN(Number(value)) &&
        !isNaN(parseFloat(value)) &&
        (Math.abs(Number(value) - parseFloat(value)) < 0.0001)
    );
}

function validateInteger(value) {
    return (
        !isNaN(Number(value)) &&
        !isNaN(parseInt(value)) &&
        (Math.abs(Number(value) - parseInt(value)) < 0.0001)
    );
}

export default function validateAttributeValue(attribute, value) {

    let valid = true;

    switch (attribute.type) {
        case 'float':
            valid = validateFloat(value) || isNil(value);
            break;
        case 'integer':
            valid = validateInteger(value) || isNil(value);
            break;
        default:
            // nop;
            break;
    }

    return valid;
}
